import { CategoryAdditionalModal } from "../../components/Modals/CategoryAddtional";
import { MenuHelper } from "../../components/Modals/Helpers/MenuHelper";
import { AdditionalModal } from "../../components/Modals/Additional";
import { CategoryModal } from "../../components/Modals/Category";
import { ProductModal } from "../../components/Modals/Product";
import { ProductAiModal } from "../../components/Modals/ProductAi";
import { NavBar } from "../../components/NavBar";
import Cardapio from "./components/cardapio";
import { useContext, useEffect, useState } from "react";
import { MenuContext } from "../../context/MenuContext";
import { FiExternalLink, FiHelpCircle, FiPlus, FiZap } from "react-icons/fi";
import { useCompany } from "../../hooks/useCompany";
import '../admin.css'
import './style.css'

export function MenuPage() {
  const { isLocalLoadRef, load, setCategoryId } = useContext(MenuContext)
  const { company } = useCompany()
  const [selectCardapio, setSelectCardapio] = useState('menu')

  function openPublicMenu() {
    const url = company.domain
      ? `https://${company.domain}`
      : `${process.env.REACT_APP_CARDAPIO}/${company.link}`

    window.open(url, '_blank', 'noopener,noreferrer')
  }

  if (selectCardapio === 'menu') {
    isLocalLoadRef.current = false
  } else if (selectCardapio === 'local') {
    isLocalLoadRef.current = true
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectCardapio])

  return (
    <NavBar>
      <CategoryModal />
      <ProductModal isLocal={false} isMenu={true} />
      <ProductAiModal isLocal={selectCardapio === 'local'} isMenu={selectCardapio === 'menu'} />
      <CategoryAdditionalModal />
      <AdditionalModal />
      <MenuHelper />

      <main className="admin-page menu-admin-page">
        <header className="admin-page-header">
          <div><h1>Cardápio</h1><p>Organize categorias, produtos e adicionais exibidos aos clientes</p></div>
          <div className="admin-header-actions">
            <button className="admin-secondary-button" type="button" onClick={openPublicMenu} disabled={!company.domain && !company.link}><FiExternalLink /><span>Acessar cardápio</span></button>
            <button className="admin-secondary-button" data-bs-toggle="modal" data-bs-target="#helperMenu"><FiHelpCircle /><span>Ajuda</span></button>
            <button className="admin-secondary-button" data-bs-toggle="modal" data-bs-target="#modalProductAi" onClick={() => setCategoryId('')}><FiZap /><span>Criar produto com IA</span></button>
            <button className="admin-primary-button" data-bs-toggle="modal" data-bs-target="#modalCategory"><FiPlus /> Nova categoria</button>
          </div>
        </header>

        <div className="menu-channel-tabs" role="tablist" aria-label="Tipo de cardápio">
          <button type="button" className={selectCardapio === 'menu' ? 'active' : ''} onClick={() => setSelectCardapio('menu')}>Cardápio delivery</button>
          <button type="button" className={selectCardapio === 'local' ? 'active' : ''} onClick={() => setSelectCardapio('local')}>Cardápio local</button>
        </div>

        {isLocalLoadRef.current === true ? <Cardapio isLocal={true} /> : <Cardapio isLocal={false} />}
      </main>
    </NavBar>
  )
}


